<template>
  <v-container fluid class="ventas__container">
    <v-data-table
      mobile-breakpoint="900"
      class="elevation-1"
      color="primary"
      :calculate-widths="true"
      :headers="entregadasTblHeaders"
      :items="entregadas"
      :footer-props="dataTableFooterProps"
      :loading="showTableLoadingMsg"
      loading-text="Cargando... Espera por favor..."
      no-data-text="Ningú servicio entregado para mostrar"
      :search="entregadasSearch"
      :expanded.sync="expanded"
      :single-expand="singleExpand"
      show-expand
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Servicios Entregados</v-toolbar-title>
          <v-text-field
            v-model="entregadasSearch"
            append-icon="mdi-magnify"
            hide-details
            label="Buscar servicio entregado"
            class="mx-4"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="dateRangeText"
            label="Ver para el rango fechas"
            prepend-icon="mdi-calendar"
            readonly
            @click="openDatePickerModal(context)"
          ></v-text-field>
          <NavDatePickerModal
            :context="context"
            @dateRangeSelected="fetchEntregadosInDateRange"
          />
        </v-toolbar>
      </template>
      <template v-slot:item.index="{ item }">
        <span>{{ item.index + 1 }}</span>
      </template>
      <template v-slot:item.id="{ item }">
        <v-chip color="default">
          <strong>
            {{ `${item.id}` }}
          </strong>
        </v-chip>
      </template>
      <template v-slot:item.nombreCliente="{ item }">
        <v-chip v-if="item.nombreCliente" color="default">
          <strong>
            {{ item.nombreCliente }}
          </strong>
        </v-chip>
        <span v-else>{{ nonExistentRecord }}</span>
      </template>
      <template v-slot:item.metodo_pago="{ item }">
        <v-chip v-if="item.metodo_pago" color="default">
          <span>
            {{ item.metodo_pago }}
          </span>
        </v-chip>
        <span v-else>{{ nonExistentRecord }}</span>
      </template>
      <template v-slot:item.nombreVendedor="{ item }">
        <span v-if="item.nombreVendedor">
          {{ item.nombreVendedor }}
        </span>
        <span v-else>{{ nonExistentRecord }}</span>
      </template>
      <template v-slot:item.cajeroEntrega="{ item }">
        <span v-if="item.cajeroEntrega">
          {{ item.cajeroEntrega }}
        </span>
        <span v-else>{{ nonExistentRecord }}</span>
      </template>
      <template v-slot:item.total="{ item }">
        <strong v-if="item.total"> ${{ formatDecimal(item.total) }} </strong>
        <span v-else>{{ nonExistentRecord }}</span>
      </template>
      <template v-slot:item.saldo="{ item }">
        <v-chip
          v-if="item.saldo || item.saldo >= 0"
          :color="item.saldo > 0 ? 'red' : 'default'"
          :text-color="item.saldo > 0 ? 'white' : 'black'"
        >
          ${{ item.saldo > 0 ? formatDecimal(item.saldo) : item.saldo }}
        </v-chip>
        <span v-else>{{ nonExistentRecord }}</span>
      </template>
      <template v-slot:item.humanFechaRecepcion="{ item }">
        <span v-if="item.humanFechaRecepcion">
          {{ item.humanFechaRecepcion }}
        </span>
        <span v-else>{{ nonExistentRecord }}</span>
      </template>
      <template v-slot:item.humanFechaEntregada="{ item }">
        <strong v-if="item.humanFechaEntregada">
          {{
            item.humanFechaEntregada !== null
              ? item.humanFechaEntregada
              : item.humanFechaActualizacion
          }}
        </strong>
        <span v-else>{{ nonExistentRecord }}</span>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td style="text-align: center" :colspan="headers.length">
          <div style="display: flex; justify-content: center">
            <div style="display: flex">
              <div style="margin-right: 5px"><strong>CODIGO:</strong></div>
              <div>
                <strong>{{ item.codigo }}</strong>
              </div>
            </div>
            <v-divider class="mx-4" vertical></v-divider>
            <div style="display: flex; justify-content: center">
              <div style="margin-right: 5px">ERA PARA ENTREGAR EL DÍA:</div>
              <div>{{ item.humanFechaEntrega }}</div>
            </div>
            <v-divider
              v-if="item.humanFechaEntregada == null"
              class="mx-4"
              vertical
            ></v-divider>
            <div v-if="item.humanFechaEntregada == null">
              * Mostrando fecha de actualización como fecha entregada
            </div>
          </div>
        </td>
      </template>
      <template v-slot:item.action="{ item }">
        <div class="ventas__table__actions-col">
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon color="red" small @click="deleteItem(item)"
            >mdi-delete</v-icon
          >
        </div>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import * as Utils from "@/services/utils";
import uiMixin from "../mixins/mixin-ui";
import mixinDataTables from "../mixins/mixin-data-tables";

import NavDatePickerModal from "../components/NavDatePickerModal.vue";

// const { getEntregadosByDateRange } = api.services.inventarioService; // from "../services/InventarioService";
// const { getClienteByID } = api.services.clientesService;
// const { getUsuarioByID } = api.services.usuariosService;

export default {
  name: "Entregados",
  components: { NavDatePickerModal },
  mixins: [uiMixin, mixinDataTables],
  data: function () {
    return {
      context: "ENTREGADOS",
      nonExistentRecord: "FOLIO NO EXISTE",
      serviciosEntregados: [],
      entregadasSearch: "",
      expanded: [],
      singleExpand: true,
      fechaEntrega: new Date().toISOString().substr(0, 10),
      defaultItem: {},
      calculateWidths: true,
      entregadasTblHeaders: [
        {
          text: "#",
          align: "left",
          sortable: true,
          value: "index",
          width: "1%",
        },
        {
          text: "Folio",
          align: "left",
          sortable: true,
          value: "id",
          width: "1%",
        },
        {
          text: "Cliente",
          align: "left",
          sortable: true,
          value: "nombreCliente",
          width: "10%",
        },
        {
          text: "Recibida por",
          align: "left",
          sortable: true,
          value: "nombreVendedor",
        },
        {
          text: "Entregada por",
          align: "left",
          sortable: true,
          value: "cajeroEntrega",
        },
        {
          text: "Forma Pago",
          align: "left",
          sortable: true,
          value: "metodo_pago",
        },
        {
          text: "Total",
          align: "left",
          sortable: true,
          value: "total",
          width: "1%",
        },
        {
          text: "Por pagar",
          align: "left",
          sortable: true,
          value: "saldo",
        },
        {
          text: "Recibido",
          align: "left",
          sortable: true,
          value: "humanFechaRecepcion",
        },
        {
          text: "Entregada el",
          align: "left",
          sortable: true,
          value: "humanFechaEntregada",
        },
        { text: "Más", value: "data-table-expand" },
      ],
    };
  },
  computed: {
    entregadas: {
      get: function () {
        return [...this.serviciosEntregados].reverse();
      },
      set: function (payload) {
        this.serviciosEntregados = payload;
      },
    },
  },
  methods: {
    getEntregadosByDateRange(){},
    getClienteByID(){},
    getUsuarioByID(){},
    nombreVendedor(id) {
      const usuario = this.getUsuarioByID(id);
      return usuario
        ? `${usuario.nombre ? usuario.nombre : ""} ${
            usuario.apellido ? usuario.apellido : ""
          }`
        : "";
    },
    nombreCliente(id) {
      const cliente = this.getClienteByID(id);
      return `${cliente.nombre} ${cliente.apellido ? cliente.apellido : ""}`;
    },
    formatDecimal(num) {
      return Utils.formatDecimal(num);
    },
    humanDateFormat: (fecha) => {
      return Utils.humanDateFormat(fecha, "es");
    },
    fetchEntregadosInDateRange(dates) {
      const self = this;
      const startDate = dates[0];
      const endDate = dates && dates[1] ? dates[1] : startDate;
      const startDateTimeStr = `${startDate} ${this.startTime}`;
      const endDateTimeStr = `${endDate} ${this.endTime}`;
      this.showTableLoadingMsg = true;

      this.getEntregadosByDateRange(startDateTimeStr, endDateTimeStr).then(
        (entregadas) => {
          console.log("[entregadas]", entregadas);
          self.entregadas = entregadas;
          self.selectedDates = dates;
          self.showTableLoadingMsg = false;
        }
      );
    },
    fetchServiciosEntregados() {
      const self = this;
      const [startDate, endDate] = this.selectedDates;
      const startDateTimeStr = `${startDate} ${this.startTime}`;
      const endDateTimeStr = `${endDate} ${this.endTime}`;
      this.getEntregadosByDateRange(startDateTimeStr, endDateTimeStr).then(
        (entregadas) => {
          console.log("[entregadas]", entregadas);
          self.entregadas = entregadas;
          self.showTableLoadingMsg = false;
        }
      );
    },
  },
  mounted() {
    this.showTableLoadingMsg = true;
    this.fetchServiciosEntregados();
  },
};
</script>

<style scoped>
.user-input {
  font-size: 13.5px;
}
.ventas__container {
  margin-top: 10px;
}

.ventas__table__actions-col {
  display: flex;
  flex-wrap: nowrap;
}
</style>